import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { memberQueryKeys } from "./memberQueryKeys";

export function useMutationSessionPackSubscriptionSessionsLeft({
  api,
}: {
  api: ApiType;
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      subscriptionId,
      quantity,
    }: {
      subscriptionId: number;
      userMemberId: string;
      quantity: number;
    }) =>
      (
        await api.memberApi.sessionPackSubscriptionSessionsLeft({
          subscriptionId,
          quantity,
        })
      ).data,
    onSuccess: async (_, { userMemberId }) => {
      await queryClient.invalidateQueries({
        queryKey:
          memberQueryKeys.userMemberSessionPackSubscriptionCurrent(
            userMemberId,
          ),
      });
    },
  });
}
